document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.pathname.match(/^\/cart\/?$/)) return;

  const form = document.querySelector('form[action="/cart"]') || document.querySelector('form#cart');
  if (!form) return;

  form.addEventListener('change', (e) => {
    const t = e.target;
    if (t && (t.name && t.name.includes('updates'))) {
      setTimeout(() => window.location.reload(), 600);
    }
  });

  const removeSelectors = [
    'a.cart-item__remove',
    'button.cart-item__remove',
    'button[name="updates[]"][value="0"]',
    'input[name="updates[]"][value="0"]'
  ];
  document.querySelectorAll(removeSelectors.join(',')).forEach(el => {
    el.addEventListener('click', () => {
      setTimeout(() => window.location.reload(), 800);
    });
  });
});
